import type { $Fetch } from 'nitropack';

import type {
  GoogleDistance,
  GoogleLocationDetails,
  GoogleSuggestion
} from '~/models/google.maps';

export default class GoogleMapsService {
  constructor(private fetch: $Fetch) { }

  async getAutocomplete(
    input: string,
    sessionToken: string
  ): Promise<GoogleSuggestion[]> {
    return await this.fetch('google/maps/autocomplete', {
      query: { input, sessionToken }
    });
  }

  async getDetails(
    placeId: string,
    sessionToken: string
  ): Promise<GoogleLocationDetails> {
    return await this.fetch('google/maps/details', {
      query: { placeId, sessionToken }
    });
  }

  async getDistance(
    lat: number,
    lng: number
  ): Promise<GoogleDistance> {
    return await this.fetch('google/maps/distance', {
      query: { lat, lng }
    });
  }
}
